export const waypointTypeIcons: { [key: number]: string } = {
  1: '/assets/icons/map-icons/help-outlined.svg',
  2: '/assets/icons/map-icons/drink-supply-outlined.svg',
  3: '/assets/icons/map-icons/refreshment-station-outlined.svg',
  4: '/assets/icons/map-icons/refreshment-hot-meal-outlined.svg',
  5: '/assets/icons/map-icons/wc-outlined.svg',
  6: '/assets/icons/map-icons/current-outlined.svg',
  7: '/assets/icons/map-icons/shower-outlined.svg',
  8: '/assets/icons/map-icons/rest-place-outlined.svg',
  9: '/assets/icons/map-icons/sleeping-bag-outlined.svg',
  10: '/assets/icons/map-icons/bicycle-service-outlined.svg',
};
